import React, { useEffect, useState, useMemo } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  commandesPardaterep,
  commandeFiltre,
} from "../actions/commandeActions";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faX } from "@fortawesome/free-solid-svg-icons";
import "react-datepicker/dist/react-datepicker.css";
import DatePicker from "react-datepicker";
import { FaCalendarAlt } from "react-icons/fa";
import { Radio, Input } from "antd";
import "../CommandeParClientFinale.css";
import { useNavigate } from "react-router-dom";
//import { RouletteSpinner } from "react-spinner-overlay";

const CommandeParClientFinale = ({ navigation, route }) => {
  const [date_d, setDateD] = useState(new Date());
  const [date_f, setDateF] = useState(new Date());
  const [wFilter, setWFiltre] = useState("T");
  const [rech, setRech] = useState("");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { commandes, loading } = useSelector(
    (state) => state.commandesListeRep
  );
  const { client } = useSelector((state) => state.client);

  // Fetch commandes based on date and filter
  useEffect(() => {
    if (wFilter === "R") {
      dispatch(commandeFiltre("Remis"));
    } else if (wFilter === "L") {
      dispatch(commandeFiltre("Livre"));
    } else {
      dispatch(commandesPardaterep(date_d, date_f, "tousF"));
    }
  }, [date_d, date_f, wFilter, dispatch]);

  const tabRech = useMemo(() => {
    if (!commandes) return [];
    if (rech === "") {
      return commandes.filter(
        (comm) => comm.cod_rep === client.cod_cli || comm?.cod_rep == undefined
      );
    } else {
      return commandes.filter((comm) =>
        comm.nom_cli.toUpperCase().includes(rech.toUpperCase())
      );
    }
  }, [commandes, rech, client.cod_cli]);

  const renderItem = (item) => (
    <div
      className="command-par-client-comm-ligne"
      style={{ backgroundColor: item?.cod_rep == null ? "#fbfcd2" : "#fff" }}
      onClick={() => navigate(`/CommandeDetails/${item._id}`)}
    >
      <div className="command-par-client-comm-name">{item.nom_cli}</div>
      <div className="command-par-client-comm-details">
        <div className="command-par-client-comm-date">
          {item.date_livraison.substring(0, 10)}{" "}
          {item.date_livraison.substring(11, 16)}
        </div>
        <div className="command-par-client-comm-amount">
          {item.totalePrix.toFixed(3)}
        </div>
        <FontAwesomeIcon
          icon={item.cmd_remis ? faCheck : faX}
          size={15}
          color={item.cmd_remis ? "green" : "red"}
          className="command-par-client-comm-icon"
        />
        <FontAwesomeIcon
          icon={item.isLivree ? faCheck : faX}
          size={15}
          color={item.isLivree ? "green" : "red"}
          className="command-par-client-comm-icon"
        />
      </div>
    </div>
  );

  return (
    <div className="command-par-client-container">
      <div className="command-par-client-cli-info">
        <div className="command-par-client-cli-info-title">
          {client?.nivcli_cloud === "R"
            ? "Réprésentant"
            : client?.nivcli_cloud === "F"
            ? "Client"
            : "Administrateur"}
          : {client?.nom_cli}
        </div>
        <div className="command-par-client-cli-info-row">
          <div className="command-par-client-cli-info-text">
            Totale Commandes:
          </div>
          <div className="command-par-client-cli-info-value">
            {commandes?.reduce((acc, i) => acc + i.totalePrix, 0)?.toFixed(3)}
          </div>
        </div>
        <div className="command-par-client-cli-info-row">
          <div className="command-par-client-cli-info-text">
            Nombre des Commandes:
          </div>
          <div className="command-par-client-cli-info-value">
            {commandes?.length}
          </div>
        </div>
        <div className="command-par-client-date-view">
          <div className="command-par-client-date-picker">
            <FaCalendarAlt size={20} color="#0A95FF" />
            <DatePicker
              selected={date_d}
              onChange={(date) => setDateD(date)}
              dateFormat="dd/MM/yyyy"
              className="command-par-client-date-input"
            />
          </div>
          <div className="command-par-client-date-picker">
            <FaCalendarAlt size={20} color="#0A95FF" />
            <DatePicker
              selected={date_f}
              onChange={(date) => setDateF(date)}
              dateFormat="dd/MM/yyyy"
              className="command-par-client-date-input"
            />
          </div>
        </div>
      </div>
      {loading && (
        <div className="loading-overlay">
          <div className="loading-text">Veuillez patienter...</div>
        </div>
      )}

      <div className="command-par-client-filter-bar">
        <Radio.Group
          value={wFilter}
          onChange={(e) => setWFiltre(e.target.value)}
          className="command-par-client-radio-group"
        >
          <Radio
            value="R"
            disabled={!commandes?.find((cmd) => cmd.cmd_remis)}
            className="command-par-client-radio"
          >
            <span className="command-par-client-filter-text">Remis</span>
          </Radio>
          <Radio
            value="L"
            disabled={!commandes?.find((cmd) => cmd.isLivree)}
            className="command-par-client-radio"
          >
            <span className="command-par-client-filter-text">Livree</span>
          </Radio>
          <Radio value="T" className="command-par-client-radio">
            <span className="command-par-client-filter-text">Tous</span>
          </Radio>
        </Radio.Group>
      </div>

      <Input
        placeholder="Taper le nom Client...."
        onChange={(e) => setRech(e.target.value)}
        value={rech}
        className="command-par-client-search-bar"
      />

      <div className="command-par-client-comm-list">
        <div className="command-par-client-comm-header">
          <div className="command-par-client-comm-header-text">Date Cmd</div>
          <div className="command-par-client-comm-header-text">Montant</div>
          <div className="command-par-client-comm-header-text">Rem</div>
          <div className="command-par-client-comm-header-text">Livr</div>
        </div>
        <div className="command-par-client-comm-items">
          {(rech === "" ? commandes : tabRech)?.map((item) => renderItem(item))}
        </div>
      </div>
    </div>
  );
};

export default CommandeParClientFinale;
